export default (d) => d;
